import React from 'react';
import PropTypes from 'prop-types';

const Toolbar = React.memo(
  ({
    board,
    allowedEntities,
    partialInstance,
    selectedInstance,
    handleCreatePartial,
    handleCancelPartial,
    clearSelectedInstance,
    updateSelectedInstance,
    deleteSelectedInstance,
    renderToolbar
  }) => {
    let options;
    let instructions;

    if (partialInstance) {
      options = [
        {
          label: 'Cancel',
          onClick: handleCancelPartial
        }
      ];
      instructions = partialInstance.instructions ?? 'Start by placing a point on the graph.';
    } else if (selectedInstance) {
      options = [
        {
          label: 'Done editing',
          onClick: clearSelectedInstance
        }
      ];

      if (selectedInstance.editOptions) {
        selectedInstance.editOptions.forEach(({label, icon, apply, key}) => {
          options.push({
            label: typeof label === 'function' ? label(selectedInstance) : label,
            onClick: () => {
              updateSelectedInstance(apply({board, instance: selectedInstance}));
            },
            icon,
            key
          });
        });
      }

      options.push({
        label: `Delete ${selectedInstance.entity.type}`,
        onClick: deleteSelectedInstance
      });
    } else {
      options = allowedEntities.map((name) => ({
        label: `Add ${name}`,
        onClick: (e) => {
          handleCreatePartial(name, null, e.nativeEvent.pointerType !== 'touch');
        }
      }));
    }

    return (
      <div role='toolbar' aria-label='Graph controls'>
        {renderToolbar(options, instructions)}
      </div>
    );
  }
);

Toolbar.propTypes = {
  board: PropTypes.object,
  allowedEntities: PropTypes.arrayOf(PropTypes.string).isRequired,
  partialInstance: PropTypes.object,
  selectedInstance: PropTypes.object,
  handleCreatePartial: PropTypes.func.isRequired,
  handleCancelPartial: PropTypes.func.isRequired,
  clearSelectedInstance: PropTypes.func.isRequired,
  updateSelectedInstance: PropTypes.func.isRequired,
  deleteSelectedInstance: PropTypes.func.isRequired,
  renderToolbar: PropTypes.func
};

Toolbar.defaultProps = {
  renderToolbar: (options, instructions) => (
    <div style={{marginBottom: '1em'}}>
      {options.map(({label, onClick, key}) => (
        <React.Fragment key={key ?? label}>
          <button type='button' onClick={onClick}>
            {label}
          </button>
          &nbsp;
        </React.Fragment>
      ))}
      <div aria-live='polite'>{instructions && <span>{instructions}</span>}</div>
    </div>
  )
};

export default Toolbar;
